export default "/images/ecc0f6ed59bd6a8427131748ef45a3e9.png";